import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=4181ba93&scoped=true&"
import script from "./Save.vue?vue&type=script&lang=ts&"
export * from "./Save.vue?vue&type=script&lang=ts&"
import style0 from "./Save.vue?vue&type=style&index=0&id=4181ba93&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181ba93",
  null
  
)

export default component.exports